import React from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

interface Props {
  clickable?: boolean
  selected?: boolean
}

const Label: React.FC<Props> = ({ children, ...others }) => {
  return <Wrapper {...others}>{children}</Wrapper>
}

Label.defaultProps = {
  clickable: false,
  selected: false,
}

const Wrapper = styled.span<Props>`
  ${({ theme: { typography } }) => typography.tag1}
  width: fit-content;
  border-radius: 5px;
  letter-spacing: 0.2px;

  ${({ clickable, selected, theme: { colors } }) => {
    if (clickable) {
      return css`
        padding: 5px 9px;
        background-color: ${selected ? colors.defaultText : colors.lightText};
        color: ${selected ? colors.bgColor : colors.deepText};
        cursor: pointer;

        ${!selected &&
        `&:hover {
          background-color: ${colors.text};
        }`}
      `
    }

    return css`
      padding: 5px 7px;
      background-color: ${colors.lightText};
      color: ${colors.deepText};
    `
  }}
`

export default Label
